module.exports = __webpack_public_path__ + "img/22.6e40f069.jpg";